<template>
  <div>
    <vue-good-wizard 
      :steps="steps"
      :onNext="nextClicked" 
      :onBack="backClicked"
      :nextStepLabel="nextStepLabel"
      :previousStepLabel="previousStepLabel"
      :finalStepLabel="finalStepLabel">
      <div slot="page1">
        <div class="form-datos">
            <div class="input" :class="{invalid: $v.arrendador.nombre.$error}">
                <label for="arrendador">Nombre *</label>
                <input type="text" id="arrendador" @blur="$v.arrendador.nombre.$touch()" placeholder="Nombre" class="form-control required" v-model="arrendador.nombre"/>
            </div>
            <div class="input">
                <label for="sexoArrendador">Sexo</label>
                <select id="sexoArrendador" v-model="arrendador.sexo">
                    <option value="1">Maculino</option>
                    <option value="2">Femenino</option>
                </select>
            </div>
            <div class="input" :class="{invalid: $v.arrendador.ciudadDomicilio.$error}">
                <label for="ciudadDomicilioArrendador">Ciudad de domicilio *</label>
                <input type="text" id="ciudadDomicilioArrendador" @blur="$v.arrendador.ciudadDomicilio.$touch()" placeholder="Ciudad de domicilio" class="form-control required" v-model="arrendador.ciudadDomicilio"/>
            </div>
            <div class="input" :class="{invalid: $v.arrendador.cedula.$error}">
                <label for="cedulaArrendador">Cedula *</label>
                <input type="text" id="cedulaArrendador" @blur="$v.arrendador.cedula.$touch()" placeholder="Cedula" class="form-control required" v-model="arrendador.cedula" />
            </div>
            <div class="input" :class="{invalid: $v.arrendador.ciudadExpedicion.$error}"> 
                <label for="ciudadeArrendador">Ciudad Expedicion *</label>
                <input type="text" id="ciudadeArrendador" @blur="$v.arrendador.ciudadExpedicion.$touch()" placeholder="Ciudad Expedicion" class="form-control required" v-model="arrendador.ciudadExpedicion" />
            </div>
        </div>
      </div>
      <div slot="page2">
        <div class="form-datos">
            <div class="input" :class="{invalid: $v.arrendatario.nombre.$error}">
                <label for="arrendatario">Nombre *</label>
                <input type="text" id="arrendatario" @blur="$v.arrendatario.nombre.$touch()" placeholder="Nombre" class="form-control required" v-model="arrendatario.nombre"/>
            </div>
            <div class="input">
                <label for="sexoArrendatario">Sexo</label>
                <select id="sexoArrendatario" v-model="arrendatario.sexo">
                    <option value="1">Maculino</option>
                    <option value="2">Femenino</option>
                </select>
            </div>
            <div class="input" :class="{invalid: $v.arrendatario.ciudadDomicilio.$error}">
                <label for="ciudadDomicilioArrendatario">Ciudad de domicilio *</label>
                <input type="text" id="ciudadDomicilioArrendatario" @blur="$v.arrendatario.ciudadDomicilio.$touch()" placeholder="Ciudad de domicilio" class="form-control required" v-model="arrendatario.ciudadDomicilio">
            </div>
            <div class="input" :class="{invalid: $v.arrendatario.cedula.$error}">
                <label for="cedulaArrendatario">Cedula *</label>
                <input type="text" id="cedulaArrendatario" @blur="$v.arrendatario.cedula.$touch()" placeholder="Cedula" class="form-control required" v-model="arrendatario.cedula"/>
            </div>
            <div class="input" :class="{invalid: $v.arrendatario.ciudadExpedicion.$error}">
                <label for="ciudadeArrendatario">Ciudad Expedicion *</label>
                <input type="text" id="ciudadeArrendatario" @blur="$v.arrendatario.ciudadExpedicion.$touch()" placeholder="Ciudad Expedicion" class="form-control required" v-model="arrendatario.ciudadExpedicion" />
            </div>
            <div class="input">
                <label for="numeroPersonas">Numero de personas a las que se arrienda *</label>
                <input type="number" id="numeroPersonas" min="1" class="form-control required" v-model="arrendatario.numeroPersonas" />
            </div>
            
        </div>
      </div>
      <div slot="page3">
        <div class="form-datos">
            <div class="input">
                <label for="tipoInmueble">Tipo de inmueble</label>
                <select id="tipoInmueble1" v-model="inmueble.tipo1">
                    <option>Casa</option>
                    <option>Apartamento</option>
                </select>
                <select id="tipoInmueble2" v-model="inmueble.tipo2">
                    <option></option>
                    <option>&nbsp;en conjunto cerrado</option>
                    <option>&nbsp;en unidad residencial</option>
                    <option>&nbsp;en condominio</option>
                    <option>&nbsp;en edificio</option>
                </select>
            </div>
            <div class="input" :class="{invalid: $v.inmueble.descripcion.$error}">
                <label for="descripcionInmueble">Descripcion completa del inmueble *</label>
                <textarea rows="3" id="descripcionInmueble" @blur="$v.inmueble.descripcion.$touch()" style="display:block;" placeholder="número de baños, alcobas, sala, comedor, patio, etc." class="form-control required" v-model="inmueble.descripcion" ></textarea>
            </div>
            <div class="input" :class="{invalid: $v.inmueble.ubicacion.$error}">
                <label for="ubicacionInmueble">Ubicacion del inmueble *</label>
                <input type="text" id="ubicacionInmueble" @blur="$v.inmueble.ubicacion.$touch()" placeholder="Nombre del conjunto, condominio o unidad residencial. direccion en caso contrario" class="form-control required" v-model="inmueble.ubicacion" />
            </div>
            <div class="input" :class="{invalid: $v.inmueble.ciudad.$error}">
                <label for="ciudadInmueble">Ciudad del inmueble *</label>
                <input type="text" id="ciudadInmueble" @blur="$v.inmueble.ciudad.$touch()" placeholder="Ciudad del inmueble" class="form-control required" v-model="inmueble.ciudad">
            </div>
        </div>
      </div>
      <div slot="page4">
        <div class="form-datos">
            <div class="input" :class="{invalid: $v.canon.valorLetras.$error}">
                <label for="canonLetras">Valor del canon en letras *</label>
                <input type="text" id="canonLetras" @blur="$v.canon.valorLetras.$touch()" placeholder="valor del canon arrendamiento en letras" class="form-control required" v-model="canon.valorLetras" />
            </div>
            <div class="input" :class="{invalid: $v.canon.valorNumeros.$error}">
                <label for="canonNumeros">Valor del canon en números *</label>
                <input type="text" id="canonNumeros" @blur="$v.canon.valorNumeros.$touch()" placeholder="valor del canon arrendamiento en números" class="form-control required" v-model="canon.valorNumeros" />
            </div>
            <div class="input" :class="{invalid: $v.canon.ubicacionPago.$error}">
                <label for="ubicacionCanon">Ubicacion pagos del canon *</label>
                <input type="text" id="ubicacionCanon" @blur="$v.canon.ubicacionPago.$touch()" placeholder="Ubicacion donde se realizarán los pagos del canon" class="form-control required" v-model="canon.ubicacionPago">
            </div>
            <div class="input" :class="{invalid: $v.canon.diaPago.$error}">
                <label for="diaCanon">Días del mes en las que se realizara el pago del canon *</label>
                <input type="text" id="diaCanon" @blur="$v.canon.diaPago.$touch()" placeholder="Días del mes en las que se realizara el pago del canon " class="form-control required" v-model="canon.diaPago">
            </div>
            <div class="input">
                <label for="numeroCanones">Numero de cánones pactados como clausula penal *</label>
                <input type="number" id="numeroCanones" min="1" class="form-control required" v-model="canon.clausulaPenal" />
            </div>
            <div class="input">
                <label for="incluyeAdministracion">El canon incluye la administracion?</label>
                <select id="incluyeAdministracion" v-model="canon.administracion">
                    <option value="1">Si</option>
                    <option value="2">No</option>
                </select>
            </div>
            <div class="input">
                <label for="incluyeServicios">El canon incluye los servicios?(acueducto, energia y gas)</label>
                <select id="incluyeServicios" v-model="canon.servicios">
                    <option value="1">Si</option>
                    <option value="2" selected="selected">No</option>
                </select>
            </div>
        </div>
      </div>
      <div slot="page5">
        <div class="form-datos">
            <div class="input">
                <label for="duracion">Numero de meses de duración del contrato *</label>
                <input type="number" id="duracion" min="1" class="form-control required" v-model="termino.meses" />
            </div>
            <div class="input">
                <label for="inicioContrato">Fecha de inicio del contrato</label>
                <select id="inicioContrato" v-model="termino.fechaInicioMes">
                    <option>Enero</option>
                    <option>Febrero</option>
                    <option>Marzo</option>
                    <option>Abril</option>
                    <option>Mayo</option>
                    <option>Junio</option>
                    <option>Julio</option>
                    <option>Agosto</option>
                    <option>Septiembre</option>
                    <option>Octubre</option>
                    <option>Noviembre</option>
                    <option>Diciembre</option>
                </select>
                <select id="inicioContrato1" v-model="termino.fechaInicioDia">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                    <option>13</option>
                    <option>14</option>
                    <option>15</option>
                    <option>16</option>
                    <option>17</option>
                    <option>18</option>
                    <option>19</option>
                    <option>20</option>
                    <option>21</option>
                    <option>22</option>
                    <option>23</option>
                    <option>24</option>
                    <option>25</option>
                    <option>26</option>
                    <option>27</option>
                    <option>28</option>
                    <option>29</option>
                    <option>30</option>
                    <option>31</option>
                </select>
                <select id="inicioContrato2" v-model="termino.fechaInicioAno">
                    <option>2018</option>
                    <option>2019</option>
                    <option>2020</option>
                    <option>2021</option>
                </select>
            </div>
            <div class="input" :class="{invalid: $v.termino.ciudad.$error}">
                <label for="ciudadContrato">Ciudad donde se firma el contrato *</label>
                <input type="text" id="ciudadContrato" @blur="$v.termino.ciudad.$touch()" placeholder="Ciudad donde se firma el contrato" class="form-control required" v-model="termino.ciudad">
            </div>
            <div class="input">
                <label for="fechaFirma">Fecha en que se firma el contrato</label>
                <select id="fechaFirma" v-model="termino.fechaFirmaMes">
                    <option>Enero</option>
                    <option>Febrero</option>
                    <option>Marzo</option>
                    <option>Abril</option>
                    <option>Mayo</option>
                    <option>Junio</option>
                    <option>Julio</option>
                    <option>Agosto</option>
                    <option>Septiembre</option>
                    <option>Octubre</option>
                    <option>Noviembre</option>
                    <option>Diciembre</option>
                </select>
                <select id="fechaFirma1" v-model="termino.fechaFirmaDia">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                    <option>13</option>
                    <option>14</option>
                    <option>15</option>
                    <option>16</option>
                    <option>17</option>
                    <option>18</option>
                    <option>19</option>
                    <option>20</option>
                    <option>21</option>
                    <option>22</option>
                    <option>23</option>
                    <option>24</option>
                    <option>25</option>
                    <option>26</option>
                    <option>27</option>
                    <option>28</option>
                    <option>29</option>
                    <option>30</option>
                    <option>31</option>
                </select>
                <select id="fechaFirma2" v-model="termino.fechaFirmaAno">
                    <option>2018</option>
                    <option>2019</option>
                    <option>2020</option>
                    <option>2021</option>
                </select>
            </div>
        </div>
      </div>
      <div slot="page6">
        <div class="form-datos">
            <div class="input" :class="{invalid: !acceptTerms}"><input id="acceptTerms" name="acceptTerms" type="checkbox" v-model="acceptTerms"> <label for="acceptTerms" class="checkbox-label">Acepto los terminos y condiciones.</label></div>
            <iframe id='pdfV' style="width:100%; height: 500px" > </iframe>
        </div>
      </div>
    </vue-good-wizard>
  </div>
</template>

<script>
import { required, email, numeric, minValue, minLength, sameAs, requiredUnless } from 'vuelidate/lib/validators'
import contratoArriendo from '../../contractTemplates/arriendo.js'
import fireStore from '../../helpers/db'
export default {
  data(){
    return {
        arrendador: {
            nombre: 'Alexander Perea Artunduaga',
            sexo: '1',
            ciudadDomicilio: 'Cali',
            cedula: '1.130.600.176',
            ciudadExpedicion: 'Cali'
            // nombre: '',
            // sexo: '1',
            // ciudadDomicilio: '',
            // cedula: '',
            // ciudadExpedicion: ''
        },
        arrendatario: {
            nombre: 'Jennifer Montes Chila',
            sexo: '2',
            ciudadDomicilio: 'Cali',
            cedula: '67.032.109',
            ciudadExpedicion: 'Cali',
            numeroPersonas: 2
            // nombre: '',
            // sexo: '1',
            // ciudadDomicilio: '',
            // cedula: '',
            // ciudadExpedicion: '',
            // numeroPersonas: 2
        },
        codeudor: {
            nombre: 'Luz Ayda Gutierrez Mejia',
            sexo: '2',
            ciudadDomicilio: 'Cali',
            cedula: '29.819.934',
            ciudadExpedicion: 'Sevilla'
            // nombre: '',
            // sexo: '1',
            // ciudadDomicilio: '',
            // cedula: '',
            // ciudadExpedicion: '',
            // numeroPersonas: 2
        },
        inmueble:{
            tipo1: 'Apartamento',
            tipo2: '',
            descripcion: '2 habitaciones y un baño',
            ubicacion: 'Avenida 5 Norte # 23N-54 piso 2',
            ciudad: 'Cali'
            // tipo1: 'Casa',
            // tipo2: '',
            // descripcion: '',
            // ubicacion: '',
            // ciudad: ''
        },
        canon:{
            valorLetras: 'Ochocientos cincuenta mil pesos',
            valorNumeros: '850.000',
            ubicacionPago: 'cuenta de ahorros de Bancolombia numero 306-814311-63',
            diaPago: '10',
            clausulaPenal: 2,
            administracion: '2',
            servicios: '2'
            // valorLetras: '',
            // valorNumeros: '',
            // ubicacionPago: '',
            // diaPago: '',
            // clausulaPenal: 2,
            // administracion: '1',
            // servicios: '2'
        },
        termino:{
            meses: 12,
            fechaInicioMes: 'Octubre',
            fechaInicioDia: '10',
            fechaInicioAno: '2019',
            ciudad: 'Cali',
            fechaFirmaMes: 'Octubre',
            fechaFirmaDia: '10',
            fechaFirmaAno: '2019'
        },
        acceptTerms: true,
        steps: [
            {
            label: 'Arrendador',
            slot: 'page1',
            },
            {
            label: 'Arrendatario',
            slot: 'page2',
            },
            {
            label: 'Inmueble',
            slot: 'page3',
            },
            {
            label: 'Valor',
            slot: 'page4',
            },
            {
            label: 'Terminos del contrato',
            slot: 'page5',
            },
            {
            label: 'Finish',
            slot: 'page6',
            }
        ],
        nextStepLabel: 'Siguiente',
        previousStepLabel: 'Atras',
        finalStepLabel: 'Generar'
    };
  },
  methods: {
    created () {
      console.log('Entro al arriendo')
    },
    nextClicked(currentPage) {
      console.log('next clicked', currentPage)
      switch(currentPage){
          case 0:
            this.$v.arrendador.$touch()
            if(this.$v.arrendador.$invalid)
                return false;
          break;
          case 1:
            this.$v.arrendatario.$touch()
            if(this.$v.arrendatario.$invalid)
                return false;
          break;
          case 2:
            this.$v.inmueble.$touch()
            if(this.$v.inmueble.$invalid)
                return false;
          break;
          case 3:
            this.$v.canon.$touch()
            if(this.$v.canon.$invalid)
                return false;
          break;
          case 4:
            this.$v.termino.$touch()
            if(this.$v.termino.$invalid)
                return false;
          break;
          case 5:
            // var checked = 
            if(!this.acceptTerms){
                return false;
            }
            let contrato = { 
                arrendador: this.arrendador,
                arrendatario: this.arrendatario,
                codeudor: this.codeudor,
                inmueble: this.inmueble,
                canon: this.canon,
                termino: this.termino,
                tipo: 'Arrendamiento'
            }
            console.log('contrato arrendamiento',JSON.stringify(contrato));

            
            var e = new contratoArriendo(contrato)
            

            // pdfMake.createPdf(e.getContractObject()).download();


            pdfMake.createPdf(e.getContractObject()).getDataUrl(function (outDoc) {
                document.getElementById('pdfV').src = outDoc;
            });

            fireStore.saveContract(contrato);

            break;
          default:
          break;

      }
      return true; //return false if you want to prevent moving to next page
    },
    backClicked(currentPage) {
      console.log('back clicked', currentPage);
      return true; //return false if you want to prevent moving to previous page
    }
  },
    validations: {
        arrendador: {
            nombre:{required},
            ciudadDomicilio: {required},
            cedula: {required},
            ciudadExpedicion: {required}
        },
        arrendatario: {
            nombre: {required},
            // sexo: '1',
            ciudadDomicilio: {required},
            cedula: {required},
            ciudadExpedicion: {required},
            // numeroPersonas: 2
        },
        inmueble:{
            descripcion: {required},
            ubicacion: {required},
            ciudad: {required}
        },
        canon:{
            valorLetras: {required},
            valorNumeros: {required},
            ubicacionPago: {required},
            diaPago: {required},
            // clausulaPenal: 2,
            // administracion: '1',
            // servicios: '2'
        },
        termino:{
            ciudad: {required}
        },

        lastName: {
        required
        }
    },
};
</script>
<style>
.form-datos div{
    display: block;
    padding-top: 10px;
}
.input {
    margin: 10px auto;
  }

  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }

  .input.inline label {
    display: inline;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }
  .input input[type='checkbox']{
      font: inherit;
    width: auto !important;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .checkbox-label{
      display: inline !important;
  }

  .input textarea {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }

  .input.invalid label {
    color: red;
  }

  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input.invalid textarea {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .hobbies button {
    border: 1px solid #521751;
    background: #521751;
    color: white;
    padding: 6px;
    font: inherit;
    cursor: pointer;
  }

  .hobbies button:hover,
  .hobbies button:active {
    background-color: #8d4288;
  }

  .hobbies input {
    width: 90%;
  }

  .submit button {
    border: 1px solid #521751;
    color: #521751;
    padding: 10px 20px;
    font: inherit;
    cursor: pointer;
  }

  .submit button:hover,
  .submit button:active {
    background-color: #521751;
    color: white;
  }

  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }

  .wizard__body__step{
    max-width: 500px;
    margin: 0 auto;
    min-height: 520px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contractWizards/arriendo.vue